import {
  differenceInCalendarDays,
  format,
  setYear,
  setMonth,
  setDate,
  addMonths,
  parse,
  differenceInDays
} from "date-fns";
import _ from "lodash";
import * as BRUtils from "@brazilian-utils/brazilian-utils";

const currencyFormatOptions = { style: "currency", currency: "BRL" };

export const asNumberString = num =>
  (num / 1)
    .toFixed(2)
    .replace(".", ",")
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
export const asIntergerString = num =>
  (num / 1)
    .toFixed(0)
    .replace(".", ",")
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
export const asMoneyString = num =>
  num.toLocaleString("pt-BR", currencyFormatOptions);
export const asMoneyStringWithoutSymbol = num =>
  num.toLocaleString("pt-BR", currencyFormatOptions).replace("R$\u00A0", "");
export const formatExpirationDate = date => {
  if (!date) return "";
  const today = new Date();
  const expirationDate = new Date(date);
  const result = differenceInCalendarDays(expirationDate, today);
  const format = result > 0 ? `${result} dias` : "Expirado";
  return format;
};
export const formatHistoricDate = date =>
  format(new Date(date), "dd/MM/yyyy - HH:mm");
export const formatDateToDDMMYYYY = date => {
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
};
export const formatMessageDate = date =>
  format(new Date(date), "HH:mm - dd/MM/yyyy");
export const convertNumberToMoney = item =>
  typeof item === "number" ? `${asMoneyString(item)}` : item;

export const convertStringMoneyToNumber = item =>
  _.isString(item) ? parseFloat(item.replace(/[\D]+/g, "")) / 100 : item;

export const formatIsoDateToDDMMYYYY = date =>
  format(new Date(date), "dd/MM/yyyy");

// 2020-06-06 em js é convertido p/ o dia 2020-06-05, p/ corrigir é necessário usar o formato
// YYYY-MM-DDTHH:mm:ss, porém isso causa erros em garantia.
// Quando isso for resolvido podemos usar formatIsoDateToDDMMYYYY.
// Se o formato estiver YYYY-MM-DDTHH:mm:ss essa função retornará valor errado, nesses casos usar formatIsoDateToDDMMYYYY
export const formatIsoDateToDDMMYYYYProper = date => {
  let dt = new Date(date);
  dt.setDate(dt.getDate() + 1);
  return format(dt, "dd/MM/yyyy");
}

export const formatDDMMYYYYToIsoDate = date => {
  const [day, month, year] = date.split("/");
  let today = new Date();
  let data = setYear(setMonth(setDate(today, day), month - 1), year);
  return data.toISOString();
};

export const formatIsoDateToDDMMYYYYHHMM = date => {
  const formattedDate = format(new Date(date), "dd/MM/yyyy 'às 'HH:mm");
  return formattedDate;
};

export const addMonthsToDDMMYYYY = (date, add) => {
  const [day, month, year] = date.split("/");
  return addMonths(new Date(year, month - 1, day), add);
};

export const formatHistoricLimitDate = date => format(new Date(date), "MM/yy");

export const formatCode = (item, number) => {
  return !item
    ? item
    : number == 2
    ? item.toString().length === 2
      ? `${item}`
      : `0${item}`
    : item.toString().length === 4
    ? `${item}`
    : item.toString().length === 3
    ? `0${item}`
    : item.toString().length === 2
    ? `00${item}`
    : `000${item}`;
};

export const parseDateDDMMYYYY = date => parse(date, "dd/MM/yyyy", new Date());

export const intervalDates = (start, end) => {
  const date_end = parseDateDDMMYYYY(end);
  const date_start = parseDateDDMMYYYY(start);
  const interval = differenceInDays(date_end, date_start);
  return interval || 0;
};

export const formatCpfOrCnpf = document => {
  if (BRUtils.isValidCPF(document)) return BRUtils.formatCPF(document);
  if (BRUtils.isValidCNPJ(document)) return BRUtils.formatCNPJ(document);
  return document;
};
